/** @module Components */

import React from 'react'

interface Session {
  text: string
  speaker?: string | string[] // Can be single speaker or array of speakers
  span?: number
  isBold?: boolean
  isMuted?: boolean
  isCentered?: boolean
}

interface ScheduleRow {
  time: string
  sessions: Session[]
}

interface MobileScheduleDayProps {
  id?: string
  title: string
  headers: {
    name: string
    location?: string
    color?: string
    textColor?: string
  }[]
  rows: ScheduleRow[]
  gridCols: number
}

export const MobileScheduleDay: React.FC<MobileScheduleDayProps> = ({
  title,
  headers,
  rows
}) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-4 md:hidden">
      <h3 className="sticky top-0 z-10 bg-white text-xl font-serif text-[#3C2416] mb-4 py-2 -mx-4 px-4">
        {title}
      </h3>
      <div className="space-y-4">
        {rows.map((row, rowIndex) => (
          <div
            key={`mobile-row-${rowIndex}`}
            className="border-b border-gray-200 pb-4 last:border-b-0"
          >
            <div className="text-sm font-bold text-white bg-[#142841] px-3 py-2 rounded-t-lg">
              {row.time}
            </div>
            <div className="space-y-2 p-3 bg-gray-50 rounded-b-lg">
              {row.sessions.map((session, sessionIndex) => {
                let currentHeaderIndex = 0

                // Find which header this session corresponds to
                for (let i = 0; i < sessionIndex; i++) {
                  currentHeaderIndex += row.sessions[i].span || 1
                }

                // Skip time column (index 0)
                const headerForSession =
                  headers[currentHeaderIndex + 1] || headers[1]

                // Skip N/A sessions or sessions that span multiple columns without content
                if (session.text === 'N/A') return null

                const renderTextWithBoldRooms = (text: string) => {
                  const roomRegex = /\(in [^)]+\)/g
                  return text.replace(roomRegex, '<strong>$&</strong>')
                }

                return (
                  <div
                    key={`mobile-session-${sessionIndex}`}
                    className={`p-3 rounded-lg border-l-4 text-[#3C2416] ${
                      session.isBold ? 'font-bold' : ''
                    } ${session.isCentered ? 'text-center' : ''}`}
                    style={{
                      backgroundColor: session.text.includes(
                        'Sanofi Diamond Lecture'
                      )
                        ? '#A0B2B4'
                        : 'white',
                      borderLeftColor: session.text.includes(
                        'Sanofi Diamond Lecture'
                      )
                        ? '#A0B2B4'
                        : session.span && session.span > 1
                          ? '#9298a8'
                          : headerForSession?.color || '#9298a8'
                    }}
                  >
                    {headerForSession && !session.span && (
                      <div className="text-xs font-semibold mb-1 opacity-75">
                        {headerForSession.name}{' '}
                        {headerForSession.location &&
                          `(${headerForSession.location})`}
                      </div>
                    )}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: renderTextWithBoldRooms(session.text)
                      }}
                    />
                    {session.speaker && (
                      <div className="text-sm italic text-gray-600 mt-1">
                        {Array.isArray(session.speaker)
                          ? session.speaker.join(', ')
                          : session.speaker}
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
